module.exports = __webpack_public_path__ + "img/ico_malaysia.ff67214f.png";